export default "__VITE_ASSET__CJirErky__"